


import { Component, Prop, Vue } from "vue-property-decorator";

import { SolarIcon } from "Web/Libs/Icons";

/* The icon of the design system ( Fred, 02/10/2026 ): takes a Material ligature, draws its
   Solar counterpart when there is one, the Material glyph otherwise. `Material` forces the
   glyph, for a menu whose icons are not ALL drawn in Solar ( one family per menu ). Sized in
   `1em` like the glyph: the `font-size` already written around keeps the hand. */
@Component
export default class Icon extends Vue {
    @Prop( { required: true } )
    Name!: string;

    @Prop( { default: false } )
    Material!: boolean;

    private get solar(): string | undefined {
        return this.Material ? undefined : SolarIcon( this.Name );
    }
}
